<template>
  <div class="flex items-center p-10 relative" :class="{ lock: lock }">
    <div class="wrapper__info-ad p-6 h-2/5 max-h-80">
      <div :class="{ lock: lock }" class="info-ad__image h-full">
        <VideoTemplate
          :key="selectedAdTest.video_link"
          :src="selectedAdTest.video_link"
        />
      </div>
      <div class="info-ad__text px-10 pt-20 pb-10">
        <div class="py-5">
          <h1 class="font-semibold">{{ selectedAdTest.video_name }}</h1>
          <h3 class="font-semibold text-sm text-indigo-500 my-2">
            {{ selectedAdTest.creator }}
          </h3>
        </div>
        <div>
          <p class="text-sm leading-6">{{ selectedAdTest.analysis }}</p>
        </div>
        <div class="flex mt-20 gap-3">
          <button
            @click="selectPreviousAdTest()"
            class="flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
          >
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="rgb(79 70 229)"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
          <button
            @click="selectNextAdTest()"
            class="flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
          >
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="rgb(79 70 229)"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import VideoTemplate from "../VideoTemplate.vue";
export default {
  components: { VideoTemplate },
  props: { lock: Boolean },
  setup() {
    const store = useStore();
    const selectedAdTest = computed(() => store.state.selectedAdTest);
    const adsTestFist_length = computed(() => store.state.adsTestFirst.length);

    const backToInitial = () => {
      store.commit("SET_ADS_TEST_FIRST", -1);
    };
    const selectNextAdTest = () => {
      if (selectedAdTest.value.index + 1 < adsTestFist_length.value) {
        store.commit("SET_ADS_TEST_FIRST", selectedAdTest.value.index + 1);
      }
    };
    const selectPreviousAdTest = () => {
      if (selectedAdTest.value.index - 1 >= 0) {
        store.commit("SET_ADS_TEST_FIRST", selectedAdTest.value.index - 1);
      }
    };
    return {
      selectedAdTest,
      selectNextAdTest,
      selectPreviousAdTest,
      backToInitial,
    };
  },
};
</script>

<style>
.lock {
  filter: blur(18px);
  pointer-events: none;
}
.wrapper__info-ad {
  @apply grid-cols-1;
  display: grid;
  gap: 20px;
}
@screen sm {
  .wrapper__info-ad {
    grid-template-columns: 0.5fr 1fr;
  }
}
.info-ad__text {
  background-image: linear-gradient(
    to right,
    rgba(252, 252, 252, 0.87),
    rgba(102, 126, 234, 0.342)
  );
  border-radius: 20px;
}
</style>
